module.exports = __webpack_public_path__ + "assets/img/travel-details-hotel.cbecf175.png";